/**
 * Provider musicale attivo.
 * Cambia questo valore per passare da Spotify a Deezer e viceversa.
 *
 * 'spotify' → usa Spotify API (richiede credenziali, soggetto a rate limit)
 * 'deezer'  → usa Deezer API tramite proxy (no auth, rate limit molto più generoso)
 */
export const MUSIC_PROVIDER = 'deezer';
